import React, { useState, useEffect } from "react";
import PageContainer from "../../Layout/Containers/PageContainer";
import { Breadcrumbs } from "../../AbstractElements";
import TandaTerimaContain from "../../Component/Tanda Terima/containers/TandaTerimaContain";
import KurirSelection from "../../Component/Tanda Terima/components/KurirSelection";

const TandaTerima = () => {
  const [showKurirSelection, setShowKurirSelection] = useState(false);
  const [selectedKurir, setSelectedKurir] = useState(null);
  const [isKurir, setIsKurir] = useState(false);
  const [loading, setLoading] = useState(true);
  
  useEffect(() => {
    const group = localStorage.getItem("group");
    setIsKurir(group === "kurir");
    
    const savedKurirString = localStorage.getItem("selectedKurir");
    
    if (group === "kurir") {
      if (savedKurirString) {
        try {
          const savedKurir = JSON.parse(savedKurirString);
          setSelectedKurir(savedKurir);
          setShowKurirSelection(false);
        } catch (error) {
          console.error("Error parsing saved kurir:", error);
          localStorage.removeItem("selectedKurir");
          setShowKurirSelection(true);
        }
      } else {
        setShowKurirSelection(true);
      }
    } else {
      setShowKurirSelection(false);
    }
    
    setLoading(false);
  }, []);
  
  const handleKurirSelect = (kurir) => {
    setSelectedKurir(kurir);
    setShowKurirSelection(false);
  };
  
  const handleReset = () => {
    localStorage.removeItem("selectedKurir");
    setSelectedKurir(null);
    setShowKurirSelection(true);
  };
  
  if (loading) {
    return <div className="loader-wrapper">Loading...</div>;
  }
  
  return (
    <PageContainer
      breadcrumbs={<Breadcrumbs parent="Tanda Terima" title="Tanda Terima" />}
    >
      {isKurir && showKurirSelection ? (
        <KurirSelection onKurirSelect={handleKurirSelect} />
      ) : (
        <TandaTerimaContain 
          selectedKurir={selectedKurir} 
          isKurir={isKurir}
          onResetKurir={handleReset}
        />
      )}
    </PageContainer>
  );
};

export default TandaTerima;